// extracted by mini-css-extract-plugin
export default {"downloadInfographicLink":"styles_download-infographic-link_evcKf"};